import { TFunction } from 'react-i18next';
import * as Yup from 'yup';

import { CountryPhone } from '../../../../../enums/countries';
import { SmartPOSTerminals } from '../../../../../types/api/smartPosTerminals';
import { Numeric } from '../../../../../types/general';
import { LabelValue } from '../../../../../types/options';
import { getPhoneorMobileNumberRegion } from '../../../../../utils/helpers/phoneNumbers';
import { yupRequiredField } from '../../../../../utils/helpers/yup';

export function smartPOSTerminalsStatuses(t: TFunction): LabelValue[] {
  return [
    { label: t('Active'), value: '1' },
    { label: t('Inactive'), value: '2' },
    { label: t('Blocked'), value: '3' },
  ];
}

export type FormFields = {
  terminalName: string;
  activationCode: Numeric;
  smartPosProviderId: number;
  pin: string;
  statusId: Numeric;
  terminalId: string;
  courierId: Numeric;
  courierName: string;
  deviceId: Numeric;
  mobileNumber?: string;
  mobileNumberRegion: CountryPhone;
};

export function getDefaultValues(
  isEditDialog: boolean,
  data: SmartPOSTerminals | undefined
): FormFields {
  return {
    terminalName: isEditDialog ? data?.terminalName ?? '' : '',
    smartPosProviderId: isEditDialog ? data?.smartPosProviderId ?? 0 : 0,
    activationCode: isEditDialog ? data?.activationCode ?? '' : '',
    pin: isEditDialog ? data?.pin ?? '0000' : '0000',
    statusId: isEditDialog ? data?.statusId ?? 1 : 1,
    terminalId: isEditDialog ? data?.terminalId ?? '' : '',
    courierName: isEditDialog ? data?.courierName ?? '' : '',
    courierId: isEditDialog ? data?.courierId ?? 0 : 0,
    deviceId: isEditDialog ? data?.deviceId ?? 0 : 0,
    mobileNumber: isEditDialog ? data?.mobileNumber ?? '' : '',
    mobileNumberRegion: getPhoneorMobileNumberRegion(data?.mobileNumber ?? ''),
  };
}

export function toApiData(data: FormFields): Partial<FormFields> {
  let apiData: Partial<FormFields> = { ...data };

  delete apiData.mobileNumberRegion;
  delete apiData.courierName;

  if (!apiData.mobileNumber) {
    delete apiData.mobileNumber;
  }

  return apiData;
}

export function getValidationSchema(t: TFunction) {
  return Yup.object().shape({
    terminalName: Yup.string().required(yupRequiredField(t, t('Name'))),
    activationCode: Yup.string().required(
      yupRequiredField(t, t('Activation Code'))
    ),
    pin: Yup.string().required(yupRequiredField(t, t('Pin'))),
    statusId: Yup.number().required(yupRequiredField(t, t('Status'))),
    smartPosProviderId: Yup.number().required(
      yupRequiredField(t, t('Smart POS Provider'))
    ),
    terminalId: Yup.string().required(yupRequiredField(t, t('Terminal ID'))),
    deviceId: Yup.number().required(yupRequiredField(t, t('Device ID'))),
    courierId: Yup.number().required(yupRequiredField(t, t('Courier ID'))),
    mobileNumber: Yup.string().optional(),
  });
}
